import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as dateFnsExports } from './p-iWCgRMLC.js';
import { d as defineCustomElement$6 } from './p-BbTg3Car.js';
import { d as defineCustomElement$5 } from './p-Dpb0Xahb.js';
import { d as defineCustomElement$4 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$3 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$2 } from './p-ClSUnmWE.js';

const datetimeReadonlyCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-block;flex-shrink:0;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{display:inline-flex;flex-direction:column;gap:.25rem}:host .datetime{align-items:center;align-self:stretch;background-color:var(--jw-theme-info-muted-message-bg-color);border-radius:.25rem;color:var(--jw-theme-info-muted-message-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;height:2rem;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .5rem}";

const WuiDateTimeReadOnly = /*@__PURE__*/ proxyCustomElement(class WuiDateTimeReadOnly extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.generateUTCDisplayString = (date) => {
            if (!date || !dateFnsExports.isValid(date)) {
                return 'yyyy-mm-dd, --:--:--';
            }
            const dateUtc = date.toISOString().substring(0, 10);
            const timeUtc = date.toISOString().substring(11, 19);
            return `${dateUtc}, ${timeUtc}`;
        };
    }
    render() {
        return (h(Host, { key: '9018a90d39f02ac3a67287293131fc555a69af91' }, h("span", { key: '05035d9b69bc43a4bf32435924f6df626d7e3869', class: "container" }, h("wui-form-field", { key: '94ac0a320884f03cf8c161fec405904829286d39', label: "UTC" }, h("span", { key: 'd6b92d5b60460320483555c9838664093a48ea31', class: "datetime" }, this.generateUTCDisplayString(this.date))))));
    }
    static get style() { return datetimeReadonlyCss; }
}, [257, "wui-datetime-readonly", {
        "date": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-datetime-readonly", "wui-box", "wui-form-field", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-datetime-readonly":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDateTimeReadOnly);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiDatetimeReadonly = WuiDateTimeReadOnly;
const defineCustomElement = defineCustomElement$1;

export { WuiDatetimeReadonly, defineCustomElement };
